const SETTINGS_FRAGMENT_TO_NAME = {
	layers: "Layers",
	domains: "Domains",
	environments: "Environments",
	"component-actions": "Component Actions",
	"component-types": "Component Types",
	"relation-types": "Relation Types",
	"monitor-functions": "Monitor Functions",
	synchronizations: "Synchronizations",
	"id-extractors": "Id Extractor",
	"component-mapping-functions": "Component Mapping Functions",
	"relation-mapping-functions": "Relation Mapping Functions",
	"component-template-functions": "Component Template Functions",
	"relation-template-functions": "Relation Template Functions",
	"sts-sources": "Data Sources",
	"demo-sources": "Demo Sources",
	"elasticsearch-sources": "Elasticsearch Sources",
	"logzio-sources": "Logzio Sources",
	"splunk-sources": "Splunk Sources",
	"cloudwatch-sources": "CloudWatch Sources",
	"azuremetrics-sources": "AzureMetrics Sources",
	"mirror-sources": "Mirror Sources",
	"export-settings": "Export Settings",
	"import-settings": "Import Settings",
};

export type SettingsFragment = keyof typeof SETTINGS_FRAGMENT_TO_NAME;

export const settingsFragmentToName = (fragment: SettingsFragment): string => SETTINGS_FRAGMENT_TO_NAME[fragment];
